<div style="width: 100%; text-align: center;"
  [style.marginTop.rem]="spinnerType=='throbber-loader'? 0.25 : 2"
  [style.marginBottom.rem]="spinnerType=='throbber-loader'? 0.25 : 2">
  <span [ngClass]="spinnerType"></span>
</div>
